<script>
import Vue from 'vue';
import { Popover } from 'element-ui';
import Tile from '~/components/tile/components/tile';

Vue.use(Popover);

export default {
    name: 'quick-links',

    components: {
        Tile
    }
}
</script>

<template>
    <el-popover
        popper-class="el-popover--quick-links"
        ref="popover1"
        placement="bottom-end"
        width="492"
        trigger="click"
    >
        <div class="col-md-4 tile-col">
            <tile label="Help Videos" link="/help/videos">
                <template slot="icon">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>A5026299-A6CC-4631-9AA8-FA2A9CACEB96</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-484.000000, -63.000000)" stroke="#363F49">
                                <g id="quicklinks/help-videos" transform="translate(484.000000, 63.000000)">
                                    <g id="video-player-subtitle">
                                        <path d="M10.305,10.852 C10.1380589,10.9469643 9.93324084,10.9461113 9.76709648,10.8497599 C9.60095211,10.7534085 9.49848798,10.5760607 9.498,10.384 L9.498,3.616 C9.49848798,3.42393933 9.60095211,3.24659146 9.76709648,3.15024008 C9.93324084,3.0538887 10.1380589,3.05303574 10.305,3.148 L16.226,6.532 C16.3939556,6.62796051 16.4976108,6.80656395 16.4976108,7 C16.4976108,7.19343605 16.3939556,7.37203949 16.226,7.468 L10.305,10.852 Z" id="Shape"></path>
                                        <path d="M23.5,17.5 C23.5,18.6045695 22.6045695,19.5 21.5,19.5 L11.5,19.5 L7.5,23.5 L7.5,19.5 L2.5,19.5 C1.3954305,19.5 0.5,18.6045695 0.5,17.5 L0.5,2.5 C0.5,1.3954305 1.3954305,0.5 2.5,0.5 L21.5,0.5 C22.6045695,0.5 23.5,1.3954305 23.5,2.5 L23.5,17.5 Z" id="Shape"></path>
                                        <path d="M3.5,16.5 L20.5,16.5" id="Shape"></path>
                                        <path d="M0.5,13.5 L23.5,13.5" id="Shape"></path>
                                        <path d="M9.5,15.5 L9.5,17.5" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Flyers" link="/media/list">
                <template slot="icon">
                    <svg width="20px" height="24px" viewBox="0 0 20 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>B3EBEE73-2A74-48E3-A62A-F48BAE0140D6</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-486.000000, -114.000000)" stroke="#363F49">
                                <g id="quicklinks/flyers" transform="translate(484.000000, 114.000000)">
                                    <g id="office-file-text">
                                        <path d="M21.207,4.5 C21.3945494,4.68749273 21.4999434,4.94180519 21.5,5.207 L21.5,22.5 C21.5,23.0522847 21.0522847,23.5 20.5,23.5 L3.5,23.5 C2.94771525,23.5 2.5,23.0522847 2.5,22.5 L2.5,1.5 C2.5,0.94771525 2.94771525,0.5 3.5,0.5 L16.793,0.5 C17.0579081,0.499525838 17.3121803,0.60418385 17.5,0.791 L21.207,4.5 Z" id="Shape"></path>
                                        <path d="M14.5,5.499 L18.5,5.499" id="Shape"></path>
                                        <path d="M5.5,14.499 L18.5,14.499" id="Shape"></path>
                                        <path d="M5.5,17.499 L18.5,17.499" id="Shape"></path>
                                        <path d="M5.5,20.499 L18.5,20.499" id="Shape"></path>
                                        <path d="M14.5,8.499 L18.5,8.499" id="Shape"></path>
                                        <path d="M14.5,11.499 L18.5,11.499" id="Shape"></path>
                                        <polyline id="Shape" points="5.5 5.499 5.5 4.499 11.5 4.499 11.5 5.499"></polyline>
                                        <path d="M8.5,4.499 L8.5,11.499" id="Shape"></path>
                                        <path d="M6.5,11.499 L10.5,11.499" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Active Journeys" link="/journeys/active">
                <template slot="icon">
                    <!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                    <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                        <title>hierarchy</title>
                        <path d="M3.5,23.5C2.673,23.5,2,22.827,2,22v-2c0-0.827,0.673-1.5,1.5-1.5h11c0.827,0,1.5,0.673,1.5,1.5v0.5h4.5
                            c0.276,0,0.5-0.224,0.5-0.5v-5.5h-5V15c0,0.827-0.673,1.5-1.5,1.5h-11C2.673,16.5,2,15.827,2,15v-2c0-0.827,0.673-1.5,1.5-1.5h11
                            c0.827,0,1.5,0.673,1.5,1.5v0.5h5v-6h-5V8c0,0.827-0.673,1.5-1.5,1.5h-11C2.673,9.5,2,8.827,2,8V6c0-0.827,0.673-1.5,1.5-1.5h11
                            C15.327,4.5,16,5.173,16,6v0.5h5V1c0-0.276,0.224-0.5,0.5-0.5S22,0.724,22,1v19c0,0.827-0.673,1.5-1.5,1.5H16V22
                            c0,0.827-0.673,1.5-1.5,1.5H3.5z M3.5,19.5C3.224,19.5,3,19.724,3,20v2c0,0.276,0.224,0.5,0.5,0.5h11c0.276,0,0.5-0.224,0.5-0.5v-2
                            c0-0.276-0.224-0.5-0.5-0.5H3.5z M3.5,12.5C3.224,12.5,3,12.724,3,13v2c0,0.276,0.224,0.5,0.5,0.5h11c0.276,0,0.5-0.224,0.5-0.5v-2
                            c0-0.276-0.224-0.5-0.5-0.5H3.5z M3.5,5.5C3.224,5.5,3,5.724,3,6v2c0,0.276,0.224,0.5,0.5,0.5h11C14.776,8.5,15,8.276,15,8V6
                            c0-0.276-0.224-0.5-0.5-0.5H3.5z"/>
                    </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Property Websites" link="/site-page/list">
                <template slot="icon">
                    <svg width="24px" height="22px" viewBox="0 0 24 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>3B23233A-358D-48B5-84EB-833F63127B92</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-484.000000, -215.000000)" stroke="#363F49">
                                <g id="quicklinks/property-websites" transform="translate(484.000000, 214.000000)">
                                    <path d="M13.5,18.5 C13.6072711,19.9493256 14.1278394,21.3375079 15,22.5" id="Shape"></path>
                                    <path d="M9,22.5 C9.87531334,21.3392378 10.3962418,19.9500954 10.5,18.5" id="Shape"></path>
                                    <path d="M7.5,22.5 L16.5,22.5" id="Shape"></path>
                                    <path d="M0.5,15.5 L23.5,15.5" id="Shape"></path>
                                    <rect id="Rectangle-path" x="0.5" y="1.5" width="23" height="17" rx="1"></rect>
                                    <path d="M10.5,13.5 L10.5,11 C10.5,10.1715729 11.1715729,9.5 12,9.5 C12.8284271,9.5 13.5,10.1715729 13.5,11 L13.5,13.5" id="Shape"></path>
                                    <path d="M8.5,7.682 L8.5,13 C8.5,13.2761424 8.72385763,13.5 9,13.5 L15,13.5 C15.2761424,13.5 15.5,13.2761424 15.5,13 L15.5,7.682" id="Shape"></path>
                                    <path d="M6.5,9.5 L11.664,4.806 C11.8546103,4.6330341 12.1453897,4.6330341 12.336,4.806 L17.5,9.5" id="Shape"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Marketing History" link="/organization/reports/marketing-overview">
                <template slot="icon">
                    <svg width="22px" height="24px" viewBox="0 0 22 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>E4DD563E-BD30-466B-96C1-8BDE26A6C4B3</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-485.000000, -264.000000)" stroke="#363F49">
                                <g id="quicklinks/marketing-history" transform="translate(484.000000, 264.000000)">
                                    <g id="Light">
                                        <polyline id="Shape" points="8.494 0.5 12.994 3.5 8.994 7"></polyline>
                                        <path d="M21,17.863 C18.8430944,22.311284 13.7594578,24.5159324 9.03797731,23.0506356 C4.31649686,21.5853388 1.37428317,16.8898926 2.11481785,12.0020423 C2.85535252,7.114192 7.05637063,3.50098254 12,3.5 L12.994,3.5" id="Shape"></path>
                                        <path d="M21.95,12.5 C21.9833333,12.8333333 22,13.1666667 22,13.5 C22.000766,14.3432776 21.894927,15.1832697 21.685,16" id="Shape"></path>
                                        <path d="M20,7.5 C20.6807588,8.40509897 21.2022294,9.41963309 21.542,10.5" id="Shape"></path>
                                        <path d="M16,4.331 C16.9064235,4.72733085 17.7489504,5.25610071 18.5,5.9" id="Shape"></path>
                                        <path d="M15,14 L15,18 C15,18.2761424 14.7761424,18.5 14.5,18.5 L9.5,18.5 C9.22385763,18.5 9,18.2761424 9,18 L9,14" id="Shape"></path>
                                        <path d="M7,13.5 L11.435,9.509 C11.7559193,9.21918516 12.2440807,9.21918516 12.565,9.509 L17,13.5" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Approved Marketing" link="/media/list#page=1&page_size=20&search=&sort=newest&type=0&status=approved">
                <template slot="icon">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>9C9B29DB-A4E0-458B-93BF-D5316E8BA356</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-484.000000, -314.000000)" stroke="#363F49">
                                <g id="quicklinks/approved-marketing" transform="translate(484.000000, 314.000000)">
                                    <g id="Light">
                                        <path d="M3.5,11.31 L3.5,21.81 C3.5,22.0861424 3.72385763,22.31 4,22.31 L11,22.31" id="Shape"></path>
                                        <path d="M0.5,10.81 L11.322,0.926 C11.7039621,0.57703313 12.2890379,0.57703313 12.671,0.926 L23.5,10.81" id="Shape"></path>
                                        <rect id="Rectangle-path" x="10.497" y="5.31" width="3" height="3" rx="0.5"></rect>
                                        <circle id="Oval" cx="17.497" cy="17.31" r="6"></circle>
                                        <path d="M20.171,15.565 L17.265,19.439 C17.1346961,19.6130687 16.9351796,19.7219206 16.718285,19.737276 C16.5013905,19.7526314 16.2885282,19.6729744 16.135,19.519 L14.635,18.019" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Landing Pages" link="/lead-capture/list">
                <template slot="icon">
                    <svg width="16px" height="24px" viewBox="0 0 16 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>9EC0F33C-C6B2-4598-A493-F99E2477A883</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-488.000000, -364.000000)" stroke="#363F49">
                                <g id="quicklinks/landing-pages" transform="translate(484.000000, 364.000000)">
                                    <g id="Light">
                                        <rect id="Rectangle-path" x="4.5" y="0.5" width="15" height="23" rx="2"></rect>
                                        <path d="M19.5,19.5 L4.5,19.5" id="Shape"></path>
                                        <path d="M10.5,15.5 L10.5,13 C10.5,12.1715729 11.1715729,11.5 12,11.5 C12.8284271,11.5 13.5,12.1715729 13.5,13 L13.5,15.5" id="Shape"></path>
                                        <path d="M8.5,9.682 L8.5,15 C8.5,15.2761424 8.72385763,15.5 9,15.5 L15,15.5 C15.2761424,15.5 15.5,15.2761424 15.5,15 L15.5,9.682" id="Shape"></path>
                                        <path d="M6.5,11.5 L11.664,6.806 C11.8546103,6.6330341 12.1453897,6.6330341 12.336,6.806 L17.5,11.5" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Emails" link="/email/list">
                <template slot="icon">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: sketchtool 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
                        <title>C7EAA62E-3CD1-4726-8E69-45982ADA96B0</title>
                        <desc>Created with sketchtool.</desc>
                        <defs></defs>
                        <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Icons-In-Use" transform="translate(-484.000000, -414.000000)" stroke="#363F49">
                                <g id="quicklinks/marketing-emails" transform="translate(484.000000, 414.000000)">
                                    <g id="email-action-home">
                                        <path d="M19.5,8.75 L23.5,11.5 L23.5,22 C23.5,22.8284271 22.8284271,23.5 22,23.5 L2,23.5 C1.17157288,23.5 0.5,22.8284271 0.5,22 L0.5,11.5 L4.5,8.75" id="Shape"></path>
                                        <polyline id="Shape" points="3.5 20.5 8.5 16.5 15.5 16.5 20.5 20.5"></polyline>
                                        <path d="M23.5,11.5 L17.5,15.5" id="Shape"></path>
                                        <path d="M0.5,11.5 L6.5,15.5" id="Shape"></path>
                                        <path d="M19.5,14.167 L19.5,1.5 C19.5,0.94771525 19.0522847,0.5 18.5,0.5 L5.5,0.5 C4.94771525,0.5 4.5,0.94771525 4.5,1.5 L4.5,14.167" id="Shape"></path>
                                        <path d="M9,6.632 L9,10.5 C9,11.0522847 9.44771525,11.5 10,11.5 L14,11.5 C14.5522847,11.5 15,11.0522847 15,10.5 L15,6.632" id="Shape"></path>
                                        <path d="M8,7.507 L11.012,4.871 C11.5776173,4.37586972 12.4223827,4.37586972 12.988,4.871 L16,7.507" id="Shape"></path>
                                        <path d="M13,11.5 L11,11.5 L11,9.5 C11,8.94771525 11.4477153,8.5 12,8.5 C12.5522847,8.5 13,8.94771525 13,9.5 L13,11.5 Z" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </template>
            </tile>
        </div>

        <div class="col-md-4 tile-col">
            <tile label="Opportunities" link="/opportunities/filter-list">
                <template slot="icon">
                    <svg version="1.1" id="Light" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                    <g id="00---ICONS-IN-USE" stroke="none" stroke-width="1" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                        <title>single-neutral-money</title>
                        <path d="M17.5,11c-0.276,0-0.5-0.224-0.5-0.5V10h-1c-0.276,0-0.5-0.224-0.5-0.5S15.724,9,16,9h2.031
                            c0.345,0,0.651-0.207,0.78-0.528c0.173-0.431-0.036-0.922-0.467-1.095l-2.063-0.826c-0.702-0.282-1.155-0.953-1.156-1.708
                            c0-0.492,0.191-0.955,0.539-1.303C16.012,3.192,16.475,3,16.967,3H17V2.5C17,2.224,17.224,2,17.5,2S18,2.224,18,2.5V3h1
                            c0.276,0,0.5,0.224,0.5,0.5S19.276,4,19,4h-2.033c-0.225,0-0.436,0.088-0.595,0.247c-0.159,0.159-0.247,0.371-0.246,0.596
                            c0,0.345,0.207,0.652,0.528,0.781l2.063,0.826c0.457,0.184,0.814,0.534,1.007,0.987c0.193,0.453,0.198,0.954,0.015,1.409
                            C19.457,9.546,18.787,9.999,18.031,10H18v0.5C18,10.776,17.776,11,17.5,11z"/>
                        <path d="M17.5,13c-3.584,0-6.5-2.916-6.5-6.5S13.916,0,17.5,0S24,2.916,24,6.5S21.084,13,17.5,13z M17.5,1
                            C14.467,1,12,3.467,12,6.5s2.467,5.5,5.5,5.5S23,9.533,23,6.5S20.533,1,17.5,1z"/>
                        <path d="M3.5,24c-0.258,0-0.477-0.201-0.498-0.458L2.54,18H0.5C0.224,18,0,17.776,0,17.5V14c0-3.033,2.467-5.5,5.5-5.5
                            S11,10.967,11,14v3.5c0,0.276-0.224,0.5-0.5,0.5H8.46l-0.462,5.542C7.977,23.799,7.758,24,7.5,24H3.5z M7.04,23l0.462-5.542
                            C7.523,17.201,7.742,17,8,17h2v-3c0-2.481-2.019-4.5-4.5-4.5S1,11.519,1,14v3h2c0.258,0,0.477,0.201,0.498,0.458L3.96,23H7.04z"/>
                        <path d="M5.5,8c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S7.706,8,5.5,8z M5.5,1c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3
                            S7.154,1,5.5,1z"/>
                    </g>
                    </svg>

                </template>
            </tile>
        </div>
        
        <span slot="reference">
            <i class="header__icon material-icons">
                apps
            </i>
        </span>
    </el-popover>
</template>

<style type="text/css">
    .el-popover--quick-links {
        width: 492px;
    }
</style>